import { routes } from './routes.ts';
import { getDefaultParam } from './utils/getDefaultParam.ts';
import { Router } from './utils/router/Router.ts';

export interface RouterBeforeNavEventDetail {
  done(goToNext?: boolean): void;
}

export const router = new Router();

const hooks = {
  before: (doneCallback: (resolve?: boolean) => void) => {
    const done = (goToNext = true) => {
      doneCallback(goToNext);
    };

    const event = new CustomEvent<RouterBeforeNavEventDetail>('beforenav', { cancelable: true, detail: { done } });

    if (window.dispatchEvent(event)) {
      done();
    }
  }
};

router
  .params(getDefaultParam)
  .hooks(hooks)
  .on(routes);